<template>
  <div id="setting-user-page" class="-font-kanit">
    <div class="head-title-page md-layout">
      <div
        :class="
          permit.acl['setting'].menus['users'].add
            ? 'md-layout-item md-large-size-50 md-medium-size-50 md-small-size-50 head-label'
            : 'md-layout-item md-large-size-60 md-medium-size-60 md-small-size-60 head-label'
        "
      >
        Users
      </div>
      <div class="mktops-subheader-filter">
        <md-field class="box">
          <md-select v-model="slcStatus" @md-selected="onChangeStatus()">
            <md-option
              v-for="(item, index) in status"
              :key="index"
              :value="index"
              >{{ item }}</md-option
            >
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item filter-table">
        <input
          type="text"
          placeholder="Search by name..."
          v-model="search"
          @input="searchOnTable"
        />
      </div>
      <div
        class="md-layout-item md-large-size-10 md-medium-size-10 md-small-size-10 add-user"
        v-if="permit.acl['setting'].menus['users'].add"
      >
        <md-button class="md-raised md-primary" @click="addUser()"
          >+ Add</md-button
        >
      </div>
    </div>

    <div id="table-setting-user">
      <div id="divTableHead">
        <div style="width: 13%;">Code</div>
        <div style="width: 23%">Fullname</div>
        <div style="width: 19%;">Username</div>
        <div style="width: 21%;">Email</div>
        <div style="width: 15%;">User Group</div>
        <div style="width: 9%;">Status</div>
      </div>
      <div id="divTableBody">
        <div
          :class="'row-bg-gray'"
          v-for="(item, uIndex) in searched"
          :key="uIndex"
          @click="onSelectRow(item)"
        >
          <div style="width: 13%">{{ item.code }}</div>
          <div
            style="width: 23%"
            class="nowrap-title -font-kanit"
            :title="item.displayname"
          >
            {{ item.displayname }}
          </div>
          <div style="width: 19%;">{{ item.username }}</div>
          <div style="width: 21%;">{{ item.email }}</div>
          <div style="width: 15%;">{{ item.user_group }}</div>
          <!-- <div style="width: 17%; padding-left: 100px;">{{ displayStatus(item.status) }}</div> -->
          <div
            style="width: 9%;"
            :class="
              item.status == 'active' ? '-status-active' : '-status-in-active'
            "
          >
            {{ displayStatus(item.status) }}
          </div>
          <!-- <div style="width: 9%;" class="-text-center"><span :class="(item.status == 'active') ? 'tab-chip -chipactive' : 'tab-chip -chipinactive'" :title="displayStatus(item.status)"></span></div> -->
        </div>
      </div>
    </div>

    <userForm
      ref="refUserForm"
      :Info="dataUserInfo"
      @onSave="saveUser"
      @onUpdate="updateUser"
    ></userForm>

    <userInfo
      ref="refUserInfo"
      :Info="dataUserInfo"
      @onEdit="editUser"
      @onDelete="deleteUser"
    ></userInfo>

    <md-dialog-alert
      style="z-index:20"
      :md-active.sync="showAlert"
      :md-title="alertTitle"
      :md-content="alertContent"
    />
  </div>
</template>

<script>
import UserService from "@/services/user";
import userForm from "./users/setting-user-form";
import userInfo from "./users/setting-user-info-tab";

import CipherService from "@/services/cipher";

import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import { POINT_CONVERSION_COMPRESSED } from "constants";

const toLower = text => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter(
      item =>
        toLower(item.email).includes(toLower(term)) ||
        item.firstname.includes(term)
    );
  }

  return items;
};

export default {
  name: "user-list",
  mixins: [validationMixin],
  components: {
    userForm,
    userInfo
  },
  computed: {
    permit() {
      return this.$jwt.decode(localStorage.getItem("token"));
    }
  },
  data() {
    return {
      slcStatus: 0,
      status: ["Active", "Inactive"],
      // status: [],
      dataUser: [],
      showPanel: false,
      dataUserInfo: {
        id: null,
        showPanel: false,
        data: {},
        default: {
          firstname: "",
          lastname: ""
        },
        select: [],
        default_under: [],
        select_promo: []
      },
      showDialog: false,

      userSaved: false,
      sending: false,
      lastUser: null,

      selectedUser: [],
      dataSearchUsers: [],
      isLoading: false,
      userStatus: false,

      manage: [],
      showSidepanel: true,

      search: null,
      searched: [],

      dataUserInfo: null,

      showAlert: false,
      alertTitle: "",
      alertContent: ""
    };
  },
  validations: {},
  created() {
    //let _self = this;

    this.loadUser();
    // this.getAllStatusUser();
  },
  methods: {
    // getAllStatusUser() {
    //   UserService.getAllStatusUser().then(response => {
    //     this.status = response;
    //   });
    // },
    onChangeStatus() {
      this.loadUser();
    },
    addUser() {
      this.$refs.refUserForm.mode = "add";
      this.$refs.refUserForm.titleDialog = "Create a New User";
      this.$refs.refUserForm.clearForm();
      if (this.dataUserInfo !== null) {
        this.dataUserInfo.default = {};
        this.dataUserInfo.select = [];
        this.dataUserInfo.default_under = {};
        this.dataUserInfo.select_promo = [];
      }
      this.$refs.refUserForm.showDialog = true;
    },
    loadUser() {
      let vStatus = this.slcStatus === 0 ? "active" : "inactive";
      UserService.getUserByStatus(vStatus).then(response => {
        //this.dataUser = response;
        // console.log(response)

        this.dataUser = response;
        this.searched = this.dataUser;
      });
    },
    newUser() {
      this.dataUserInfo.data = {};
      this.dataUserInfo.showPanel = true;
    },

    deleteUser(id) {
      UserService.deleteUser(id).then(response => {
        //this.dataUser = response;
        //this.dataUserInfo.data = response;
        this.loadUser();
      });
    },

    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },

    saveUser(data) {
      //if(data.status == true) data.user_status = "Active"
      /* TAP APPROVAL */
      let dataSelect = [];
      for (let i = 0; i < data.select.length; i++) {
        dataSelect.push({
          code: data.select[i].code
        });
      }
      let datas = {
        code: data.code,
        select: dataSelect
      };
      UserService.saveApproval(datas).then(response => {
        // console.log("response ==>", response);
      });

      /* TAP VIEW PROMOTION */
      let dataSelectPromo = [];
      for (let i = 0; i < data.select_promo.length; i++) {
        dataSelectPromo.push({
          code: data.select_promo[i].code
        });
      }
      let datasPromo = {
        code: data.code,
        select: dataSelectPromo
      };
      UserService.saveViewPromo(datasPromo).then(response => {
        // console.log("response ==>", response);
      });

      UserService.saveUser(data)
        .then(response => {
          this.loadUser();
          this.$refs.refUserForm.showDialog = false;
        })
        .catch(error => {
          // alert(error.response.data.message)
          this.alertTitle = "Alert";
          this.alertContent = error.response.data.message;
          this.showAlert = true;
        });
    },
    updateUser(data) {
      /* TAP APPROVAL */
      let dataSelect = [];
      for (let i = 0; i < data.select.length; i++) {
        dataSelect.push({
          code: data.select[i].code
        });
      }
      let datas = {
        code: data.code,
        select: dataSelect
      };
      UserService.saveApproval(datas).then(response => {
        // console.log("response ==>", response);
      });

      /* TAP VIEW PROMOTION */
      let dataSelectPromo = [];
      for (let i = 0; i < data.select_promo.length; i++) {
        dataSelectPromo.push({
          code: data.select_promo[i].code
        });
      }
      let datasPromo = {
        code: data.code,
        select: dataSelectPromo
      };
      UserService.saveViewPromo(datasPromo).then(response => {
        // console.log("response ==>", response);
      });

      UserService.updateUser(data).then(response => {
        this.loadUser();
        this.$refs.refUserForm.showDialog = false;
      });
    },
    showUserInfo() {
      this.showDialog = true;
    },
    displayStatus(status) {
      // if (status == "active") {
      //     return "<div style='color:green;weight:bold'>Active</div>"; //;//'<md-badge class="md-square md-primary" md-content="Active" />'
      // } else {
      //     return "<div style=color:gray;weight:bold>Inactive</div>"; //</md-badge>';//'<md-badge class="md-square" md-content="Inactive" />'
      // }

      if (status !== undefined) {
        return status.substr(0, 1).toUpperCase() + status.substr(1);
      } else {
        return "Inactive";
      }
    },
    searchOnTable() {
      this.searched = searchByName(this.dataUser, this.search);
    },
    onSelectRow(row) {
      let dataApprove = [];
      UserService.getInfo(row._id).then(async response => {
        //-- START SET CONFIG --//
        let datas = { code: response.code, boss_code: response.boss_code };
        // let dataApproval = await UserService.getUserApproval(datas);
        let [dataApproval, dataViewPromo] = await Promise.all([
          UserService.getUserApproval(datas),
          UserService.getUserUnder(response.code)
        ]);

        this.dataUserInfo = response;
        this.dataUserInfo["default"] = dataApproval.default
          ? dataApproval.default
          : [];
        this.dataUserInfo["select"] = dataApproval.select
          ? dataApproval.select
          : [];

        /* START TRELLO #533 : TAB VIEW PROMOTION */
        // let dataViewPromo = await UserService.getUserUnder(response.code);
        this.dataUserInfo["default_under"] = dataViewPromo.default
          ? dataViewPromo.default
          : [];
        this.dataUserInfo["select_promo"] = dataViewPromo.select
          ? dataViewPromo.select
          : [];
        /* END TRELLO #533 : TAB VIEW PROMOTION */
        //-- END SET CONFIG --//

        // this.dataUserInfo["datamyhr"] = [
        //   {
        //     code: "391004",
        //     firstname: "ดนุพล",
        //     lastname: "สยามวาลา"
        //   },
        //   {
        //     code: "600337",
        //     firstname: "ณัฐธภัทร์",
        //     lastname: "กตัญญูเสริมพงษ์"
        //   }
        // ];

        // this.dataUserInfo["datasave"] = [
        //   {
        //     code: "361011",
        //     firstname: "กรรณกร",
        //     lastname: "คมนา"
        //   },
        //   {
        //     code: "560240",
        //     firstname: "สุนิสา",
        //     lastname: "ทรัพย์ทิพยรัตนา"
        //   }
        // ];

        // for (let i = 0; i < this.dataUserInfo["datamyhr"].length; i++) {
        //   this.dataUserInfo["datamyhr"][i]["type"] = "myhr";
        // }
        // for (let i = 0; i < this.dataUserInfo["datasave"].length; i++) {
        //   this.dataUserInfo["datasave"][i]["type"] = "config";
        // }

        // let dataApprove = this.dataUserInfo["datamyhr"].concat(
        //   this.dataUserInfo["datasave"]
        // );
        // this.dataUserInfo["data_approve"] = dataApprove;

        this.$refs.refUserInfo.showSidepanel = true;
      });
    },
    editUser(row) {
      UserService.getInfo(row._id).then(async response => {
        //-- START SET CONFIG --//
        let datas = { code: response.code, boss_code: response.boss_code };
        // let dataApproval = await UserService.getUserApproval(datas);
        let [dataApproval, dataViewPromo] = await Promise.all([
          UserService.getUserApproval(datas),
          UserService.getUserUnder(response.code)
        ]);

        this.dataUserInfo = response;
        this.dataUserInfo["default"] = dataApproval.default
          ? dataApproval.default
          : [];
        this.dataUserInfo["select"] = dataApproval.select
          ? dataApproval.select
          : [];

        /* START TRELLO #533 : TAB VIEW PROMOTION */
        this.dataUserInfo["default_under"] = dataViewPromo.default
          ? dataViewPromo.default
          : [];
        this.dataUserInfo["select_promo"] = dataViewPromo.select
          ? dataViewPromo.select
          : [];
        //-- END SET CONFIG --//

        //-- START SET CONFIG --//
        // this.dataUserInfo["datamyhr"] = [
        //   {
        //     code: "391004",
        //     firstname: "ดนุพล",
        //     lastname: "สยามวาลา"
        //   },
        //   {
        //     code: "600337",
        //     firstname: "ณัฐธภัทร์",
        //     lastname: "กตัญญูเสริมพงษ์"
        //   }
        // ];

        // this.dataUserInfo["datasave"] = [
        //   {
        //     code: "361011",
        //     firstname: "กรรณกร",
        //     lastname: "คมนา"
        //   },
        //   {
        //     code: "560240",
        //     firstname: "สุนิสา",
        //     lastname: "ทรัพย์ทิพยรัตนา"
        //   }
        // ];

        // for (let i = 0; i < this.dataUserInfo["datamyhr"].length; i++) {
        //   this.dataUserInfo["datamyhr"][i]["type"] = "myhr";
        // }
        // for (let i = 0; i < this.dataUserInfo["datasave"].length; i++) {
        //   this.dataUserInfo["datasave"][i]["type"] = "config";
        // }

        // let dataApprove = this.dataUserInfo["datamyhr"].concat(
        //   this.dataUserInfo["datasave"]
        // );
        // this.dataUserInfo["data_approve"] = dataApprove;
        //-- END SET CONFIG --//

        this.dataUserInfo.password = "";
        // delete this.dataUserInfo.password;
        this.$refs.refUserForm.mode = "edit";
        this.$refs.refUserForm.titleDialog = "Edit User";
        this.$refs.refUserForm.showDialog = true;
      });
    }
  }
};
</script>

<style lang="scss">
#setting-user-page {
  padding: 20px;
  background-color: white;

  .head-title-page {
    font-size: 20px;
    font-weight: bold;
    margin: 5px;

    .head-label {
      padding-top: 8px;
    }

    .filter-table {
      text-align: right;
      width: 30%;
      padding-right: 25px;
      padding-right: 15px;

      input {
        width: 100%;
        padding-left: 8px;
        height: 36px;
        border: 1px solid #ddd;
        border-radius: 5px;
        background: #fff;
      }

      ::placeholder {
        color: #bdbdbd;
        opacity: 1;
      }
    }

    .add-user {
      .md-button {
        margin: 0;
        height: 35px;
      }
    }
  }

  #table-setting-user {
    #divTableHead {
      width: 99.3%;
      display: -webkit-inline-box;
      font-family: lato;
      font-size: 13px;
      font-weight: bold;
      margin-top: 15px;
      margin-bottom: 10px;

      div {
        // border: 1px solid pink;
        padding-left: 5px;
        padding-right: 5px;

        &.-text-right {
          text-align: right;
        }

        &.-text-center {
          text-align: center;
        }
      }
    }

    #divTableBody {
      width: 100%;
      height: calc(100vmin - 131px);
      display: block;
      overflow-y: scroll;
      font-family: lato;
      font-size: 13px;

      .-font-kanit {
        font-size: 14px !important;
        font-family: kanit;
        font-weight: 300;
      }

      > div {
        width: 100%;
        height: 35px;
        display: -webkit-inline-box;
        padding-top: 5px;
        padding-bottom: 5px;

        div {
          // border: 1px solid pink;
          padding-left: 5px;
          padding-right: 5px;

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }

          &.nowrap-title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          &.-status-active {
            color: green;
            font-weight: bold;
          }

          &.-status-in-active {
            color: gray;
            font-weight: bold;
          }

          // .tab-chip {
          //     padding-left: 7px;
          //     padding-right: 7px;
          //     border-radius: 35px;
          //     color: white;
          //     font-size: 12px;
          //     padding-top: 3px;
          //     padding-bottom: 3px;
          //     margin-left: 5px;

          //     &.-chipactive {
          //         color: green;
          //         background-color: green;
          //         font-size: 10px;
          //         margin-left: 0px;
          //         padding: 1px 7px;
          //         border-radius: 50px;
          //     }

          //     &.-chipinactive {
          //         color: gray;
          //         background-color: gray;
          //         font-size: 10px;
          //         margin-left: 0px;
          //         padding: 1px 7px;
          //         border-radius: 50px;
          //     }

          // }
        }
      }

      .row-bg-gray:hover {
        background: rgba(236, 236, 235, 1);
        cursor: pointer;
      }

      &::-webkit-scrollbar {
        height: 7px;
        width: 8px;
      }
    }
  }

  .mktops-subheader-filter {
    height: 36px;

    .md-field.box > .md-input.md-select-value,
    .md-field.box > .md-menu.md-select {
      font-size: 14px;
      width: 115.72px;
      height: 36px;
      margin: 0px 20px;
    }

    .md-field.md-field.box {
      margin-top: unset;
      margin-bottom: unset;
      padding: unset;
    }

    .md-field:after,
    .md-field:before {
      left: unset;
    }

    .md-field.box .md-input.md-input.md-select-value,
    .md-field.box label {
      font-size: 14px;
      padding-left: 12px;
      padding-top: 3px;
      color: #727272;
    }

    .md-field.box .md-select {
      background-color: #efefef;
      border-radius: 3px;
    }
  }

  // .bg-backdrop {
  //     background: rgba(0, 0, 0, .6);
  //     width: 100%;
  //     height: 100%;
  //     position: absolute;
  //     z-index: 7;
  //     top: 0;
  //     left: 0;
  // }
}

// .md-menu-content-big.menu-vert {
//     z-index: 20;
//     top: 80px !important;
//     left: unset !important;
//     right: 205px !important;
// }
</style>
